/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Optional: present only beside `invalid`, when the Recording already exists (4.1.4.3).
 * @export
 * @interface CreateRecordingResponseConflict
 */
export interface CreateRecordingResponseConflict {
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingResponseConflict
     */
    kind: CreateRecordingResponseConflictKindEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingResponseConflict
     */
    recordingId: string;
}


/**
 * @export
 */
export const CreateRecordingResponseConflictKindEnum = {
    SameArtist: 'same_artist',
    OtherArtist: 'other_artist'
} as const;
export type CreateRecordingResponseConflictKindEnum = typeof CreateRecordingResponseConflictKindEnum[keyof typeof CreateRecordingResponseConflictKindEnum];


/**
 * Check if a given object implements the CreateRecordingResponseConflict interface.
 */
export function instanceOfCreateRecordingResponseConflict(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "kind" in value;
    isInstance = isInstance && "recordingId" in value;

    return isInstance;
}

export function CreateRecordingResponseConflictFromJSON(json: any): CreateRecordingResponseConflict {
    return CreateRecordingResponseConflictFromJSONTyped(json, false);
}

export function CreateRecordingResponseConflictFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecordingResponseConflict {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'kind': json['kind'],
        'recordingId': json['recording_id'],
    };
}

export function CreateRecordingResponseConflictToJSON(value?: CreateRecordingResponseConflict | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'kind': value.kind,
        'recording_id': value.recordingId,
    };
}

